import SatisfactionMessageScale from './SatisfactionMessageScale';

export default SatisfactionMessageScale;
